import { render, staticRenderFns } from "./DynamicMainFieldInputWidget.vue?vue&type=template&id=13ca2dff&scoped=true"
import script from "./DynamicMainFieldInputWidget.vue?vue&type=script&lang=js"
export * from "./DynamicMainFieldInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca2dff",
  null
  
)

export default component.exports